import { Navigate } from "react-router-dom";
import { isSupervisorAndSuperAdmin } from "../utils/auth";

const SupervisorAndSuperAdminRoute = ({ children }) => {
	if (!isSupervisorAndSuperAdmin()) {
		return <Navigate to="/dashboard" replace />;
	}
	return children;
};

export default SupervisorAndSuperAdminRoute;
